import { z } from "zod";

export const documentTypeEnum = z.enum([
  "REGLAMENTO",
  "MANUAL_NORMAS",
  "ESCRITURA_MATRIZ",
  "PLAN_EMERGENCIA",
  "PLAN_RACIONAMIENTO",
  "SEGURO",
  "CONTRATO",
  "ACTA_ASAMBLEA",
  "ACTA_JUNTA",
  "CONVOCATORIA",
  "RESOLUCION",
  "COMUNICADO",
  "PRESUPUESTO",
  "INFORME",
  "OTRO",
]);
export const registryStatusEnum = z.enum(["NOT_REGISTERED", "PENDING", "REGISTERED"]);
export const contractStatusEnum = z.enum(["ACTIVE", "EXPIRED", "PENDING_RENEWAL", "TERMINATED"]);
export const legalActionStatusEnum = z.enum(["OPEN", "IN_PROGRESS", "RESOLVED", "CLOSED"]);

export const createDocumentSchema = z.object({
  title: z.string().min(1),
  documentType: documentTypeEnum,
  version: z.string().min(1, "Versión requerida (ej. 1.0)"),
  fileUrl: z.string().url(),
  effectiveDate: z.coerce.date().optional().nullable(),
  registryStatus: registryStatusEnum.optional().default("NOT_REGISTERED"),
  registryDate: z.coerce.date().optional().nullable(),
  // The meeting this document belongs to (an acta), so it shows in both modules.
  meetingId: z.string().optional().nullable(),
});

// Editing an existing document record: all fields optional; fileUrl replace-in-place allowed.
export const updateDocumentSchema = z.object({
  title: z.string().min(1).optional(),
  documentType: documentTypeEnum.optional(),
  version: z.string().min(1).optional(),
  fileUrl: z.string().url().optional(),
  effectiveDate: z.coerce.date().optional().nullable(),
  registryStatus: registryStatusEnum.optional(),
  registryDate: z.coerce.date().optional().nullable(),
  meetingId: z.string().optional().nullable(),
});

export const createContractSchema = z.object({
  vendorName: z.string().min(1),
  serviceType: z.string().min(1),
  startDate: z.coerce.date(),
  endDate: z.coerce.date(),
  renewalDate: z.coerce.date().optional().nullable(),
  amount: z.coerce.number().nonnegative(),
  fileUrl: z.string().url().optional().nullable(),
  notes: z.string().optional().nullable(),
});

export const updateContractSchema = createContractSchema.partial().extend({
  status: contractStatusEnum.optional(),
});

export const createLegalActionSchema = z.object({
  title: z.string().min(1),
  description: z.string().min(1),
  relatedUnit: z.string().optional().nullable(),
  assignedTo: z.string().optional().nullable(),
  dueDate: z.coerce.date().optional().nullable(),
});

export const updateLegalActionSchema = z.object({
  title: z.string().optional(),
  description: z.string().optional(),
  status: legalActionStatusEnum.optional(),
  assignedTo: z.string().optional().nullable(),
  dueDate: z.coerce.date().optional().nullable(),
  resolution: z.string().optional().nullable(),
});
